{
  "Poll_Viewer_VoteCount_Modal_Voters_Private_Voter": "Private User",
  "Poll_Viewer_ShowAllOptions_CTA": "ดูตัวเลือกทั้งหมด",
  "Spoiler_Reveal_Tooltip": "คลิกเพื่อเปิด",
  "VerticalEmbed_Event_Error_Subtitle": "อีเวนท์นี้ถูกลบไปแล้ว กรุณาเปลี่ยนเป็นอีเวนท์อื่น",
  "Viewer_Toolbar_Twitter_Tooltip": "Tweet สิ่งนี้",
  "CollapsibleListPlugin_CollapseButton_AriaLabel": "รายการยุบแล้ว",
  "Spoiler_Reveal_Video_CTA": "แสดงวิดีโอ",
  "VerticalEmbed_Pricing_Plan": "แพ็กเกจเท่านั้น",
  "Image_Expand_Button_AriaLabel": "ขยายรูปภาพ",
  "VerticalEmbed_From_Price": "เริ่มต้นที่",
  "Poll_Viewer_ShowAllResults_CTA": "ดูผลทั้งหมด",
  "Spoiler_Reveal_Image_Placeholder": "รูปภาพนี้มีการสปอยล์",
  "VerticalEmbed_Ribbon": "ยอดขาย",
  "Audio_Plugin_Elapsed_Time_Slider_AriaLabel": "แถบเลื่อนเพื่อค้นหา",
  "VerticalEmbed_Error_Subtitle": "รายการนี้ถูกลบไปแล้ว กรุณาเปลี่ยนเป็นรายการอื่น",
  "Poll_Viewer_Multiselect_Footer": "คุณสามารถโหวตได้มากกว่า 1 คำตอบ",
  "Audio_Plugin_More_Actions_Button_AriaLabel": "แสดงตัวควบคุมเสียงเพิ่มเติม",
  "VerticalEmbed_Booking_Fetch_Error_Title": "ไม่สามารถโหลดบริการ",
  "Fullscreen_Close_Button_AriaLabel": "ปิด",
  "VerticalEmbed_Event_Fetch_Error_Title": "ไม่สามารถโหลดอีเวนท์",
  "UploadFile_Viewer_Loader": "กำลังโหลด {{fileType}}",
  "Polls_Plugin_User_Avatar_Alt": "ใช้รูปประจำตัว",
  "Preview_ReadMore_Label": "อ่านเพิ่มเติม",
  "Spoiler_Insert_Tooltip": "Spoiler",
  "VerticalEmbed_Product_Fetch_Error_Title": "ไม่สามารถโหลดสินค้า",
  "Fullscreen_Shrink_Button_AriaLabel": "หด",
  "Audio_Plugin_Volume_Control_Slider_AriaLabel": "ความดัง",
  "Spoiler_Reveal_Gallery_Placeholder": "แกลเลอรีนี้มีการสปอยล์",
  "Fullscreen_Expand_Button_AriaLabel": "ขยาย",
  "VerticalEmbed_Bookings_Button": "จองเลย",
  "Audio_Plugin_Volume_Control_Unmute_AriaLabel": "เปิดเสียง",
  "Spoiler_Reveal_Gallery_CTA": "แสดงแกลเลอรี",
  "Poll_Viewer_ShowLess_CTA": "แสดงลดลง",
  "VerticalEmbed_Disabled_Button_Tooltip": "Product page will be available once you publish your site.",
  "Audio_Plugin_Volume_Control_Mute_AriaLabel": "ปิดเสียง",
  "Poll_Viewer_VoteCount_Modal_Voters_Anonymous": "+{{anonNumber}} ไม่ระบุชื่อ",
  "Poll_Viewer_VoteCount_Modal_Voters_CTA_Follow": "ติดตาม",
  "VerticalEmbed_Products_Button": "ซื้อเลย",
  "Poll_Viewer_Toast_Error_ServerDown": "ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ กรุณาลองอีกครั้งภายหลัง",
  "Poll_Viewer_VoteCount_Modal_Voters_Header": "คนโหวตให้คำตอบนี้ {{count}} คน",
  "Poll_Viewer_VoteCount": "โหวด {{number}} คน",
  "VerticalEmbed_Events_Button": "ลงทะเบียนตอนนี้",
  "Spoiler_Reveal_Image_CTA": "แสดงรูปภาพ",
  "Poll_Viewer_Toast_Error_Connection": "ไม่มีอินเตอร์เน็ตกรุณาตรวจสอบการเชื่อมต่อ",
  "Poll_Viewer_Visibility_Owner_Footer": "คุณเท่านั้นที่สามารถมองเห็นผลการโหวต",
  "VerticalEmbed_Booking_Error_Title": "ลบบริการแล้ว",
  "VerticalEmbed_Product_Error_Title": "ลบสินค้าแล้ว",
  "VerticalEmbed_Fetch_Error_Subtitle": "ไม่สามารถโหลดข้อมูลรายการ",
  "Poll_Viewer_VoteCount_Modal_Voters_Header_plural": "คนโหวตให้คำตอบนี้ {{count}} คน",
  "VerticalEmbed_Event_Error_Title": "ลบอีเวนท์แล้ว",
  "CollapsibleListPlugin_ExpandButton_AriaLabel": "รายการเผยแล้ว",
  "Audio_Plugin_Cover_Alt": "ภาพปกไฟล์เสียง",
  "Spoiler_Reveal_Video_Placeholder": "วิดีโอนี้มีการสปอยล์",
  "VerticalEmbed_Product_Fetch_Error_Subtitle": "พบปัญหาทางเทคนิค โปรดตรวจสอบการเชื่อมต่ออินเทอร์เน็ตจากนั้นลองอีกครั้ง",
  "VerticalEmbed_Fetch_Error_Title": "โหลดรายการไม่สำเร็จ",
  "Poll_Viewer_Option_AriaLabel_Unchecked": "unchecked",
  "VerticalEmbed_Product_Error_Subtitle": "สินค้านี้ถูกลบไปแล้ว กรุณาเปลี่ยนเป็นสินค้าอื่น",
  "VerticalEmbed_Booking_Error_Subtitle": "บริการนี้ถูกลบไปแล้ว กรุณาเปลี่ยนเป็นบริการอื่น",
  "Preview_SeeFullPost_Label": "ดูโพสต์ฉบับเต็ม",
  "UploadFile_Viewer_Download": "ดาวน์โหลด {{fileType}}",
  "VerticalEmbed_Units_Hour": "{{hours}} ชม.",
  "VerticalEmbed_Units_Minute": "{{minutes}} นาที",
  "VerticalEmbed_Event_Fetch_Error_Subtitle": "พบปัญหาทางเทคนิค โปรดตรวจสอบการเชื่อมต่ออินเทอร์เน็ตจากนั้นลองอีกครั้ง",
  "VerticalEmbed_Error_Button": "แทนที่",
  "VerticalEmbed_Error_Title": "ลบรายการแล้ว",
  "VerticalEmbed_Booking_Fetch_Error_Subtitle": "พบปัญหาทางเทคนิค โปรดตรวจสอบการเชื่อมต่ออินเทอร์เน็ตจากนั้นลองอีกครั้ง",
  "Poll_Viewer_Option_AriaLabel_Checked": "checked"
}
